import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PatientProtectedRouteProps {
    children: ReactNode;
}

const PatientProtectedRoute: React.FC<PatientProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading, isPatient, user } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user?.must_change_password && location.pathname !== '/change-password') {
        return <Navigate to="/change-password" replace />;
    }

    if (!isPatient()) {
        // Non-patients get redirected to their appropriate dashboard
        const redirectTo = user?.doctor ? '/doctor-dashboard' : '/admin-dashboard';
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};

export default PatientProtectedRoute;
